import { _, React, Component, PropTypes } from 'utils';
import Icon from '../Icon';

export default class Suggestion extends Component {

	constructor(props)
	{
		super(props);

		this.handleSelect = this.handleSelect.bind(this);
	}

	static propTypes = {
		item: PropTypes.object,
		active: PropTypes.bool,
		onSelect: PropTypes.func
	}

	handleSelect(event) {
		event.preventDefault();
		
		var { onSelect, item} = this.props;
		onSelect(item);
	}

	render() {
		var { item, active } = this.props;
		var css = [];

		if(active) {
			css.push('active');
		}
		var description = item.description;
		if(item.src == 'language'){
			description = item.searchname;
		}
		return <li className={css.join(' ')}>
			<a href="#" onClick={this.handleSelect}>
				<Icon type={item.src} />{ description }
			</a>
		</li>
	}
}


// WEBPACK FOOTER //
// ./src/modules/app/search/suggestions/suggestion.js